import React from 'react';
import { useLanguage } from '../../Contexts/LanguageContext';
import './Footer.scss';


const Footer = () => {
  const { getLanguageData } = useLanguage();
const data = getLanguageData();

  const footerContent = data.footer;

  return (
    <>      
      <footer>        
          <div className="section-spacing footer-section">    
            <div className='container'>      
              {footerContent}
          </div>             
        </div>      
      </footer>
    </>
  );
};

export default Footer;
